module.exports = __webpack_public_path__ + "img/q31-4.c00ca08d.jpg";